import { useSelector } from "react-redux";
import TableHeaderCell from "../common/table/tableHeaderCell";
import { t } from "i18next";
import { useAppDispatch } from "../../redux";
import {
  fetchCitizensBySearchParams,
  updateOrder,
  updateOrderAs,
  updatePage,
} from "../../redux/reducer/citizensReducer";
import { onClickOrder } from "../../utils/helpers";

const TableHeader = () => {
  const dispatch = useAppDispatch();

  const { citizens } = useSelector((state: any) => state);
  const { order, orderAs } = citizens;

  const OnClickOrder = async (orderType: string) => {
    const { orderOption, listOrderAs } = onClickOrder(
      order,
      orderAs,
      orderType
    );
    dispatch(updateOrder(orderOption));
    dispatch(updateOrderAs(listOrderAs));
    dispatch(updatePage(1));
    dispatch(fetchCitizensBySearchParams());
  };

  const getIcon = (orderType: String) => {
    let icon = "unfold_more";

    if (order === orderType) {
      if (orderAs === "desc") {
        icon = "keyboard_arrow_up";
      } else {
        icon = "keyboard_arrow_down";
      }
    }
    return icon;
  };

  return (
    <thead>
      <tr>
        <TableHeaderCell
          icon={getIcon("fiscalCode")}
          onClickOrder={() => {
            OnClickOrder("fiscalCode");
          }}
          className="regionalCodeWidth"
          label={t("fiscale-code")}
        />
        <TableHeaderCell
          icon={getIcon("name")}
          onClickOrder={() => {
            OnClickOrder("name");
          }}
          label={t("name")}
        />
        <TableHeaderCell
          icon={getIcon("surname")}
          onClickOrder={() => {
            OnClickOrder("surname");
          }}
          label={t("surname")}
        />
        <TableHeaderCell />
      </tr>
    </thead>
  );
};

export default TableHeader;
